import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-material-design-icons-page-configurator',
	templateUrl:'./MaterialDesignIconsPageConfiguratorPluginCompPage.html',
	styles: [],
	styleUrls:['./MaterialDesignIconsPageConfiguratorPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class MaterialDesignIconsPageConfiguratorPluginCompPage
{
	mdContent_1072 = `\`\`\`java
import com.jwebmp.plugins.materialdesignicons.MaterialDesignIconsPageConfigurator;
\`\`\``;
	mdContent_1073 = `\`\`\`java
module com.myapp {
    requires com.jwebmp.plugins.materialdesignicons;
}
\`\`\``;
}
